module.exports = __webpack_public_path__ + "static/media/gorilla2.676f10bf.png";